import type { EquipmentInfo } from '@az3fr/core';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { api } from '@/api/api-client';
import { equipmentSliceActions } from '@/entities/equipment/model/equipment.slice';
import { useAppDispatch } from '@/hooks/store.hook';

interface EquipmentsResponse {
	data: EquipmentInfo[];
}

// @todo: it should not be paginated, we should get all exercises
function useLoadAllEquipmentsRawQuery() {
	const dispatch = useAppDispatch();

	const queryResult = useQuery<EquipmentsResponse, Error>({
		queryKey: ['equipments', 'all', 'raw'],
		queryFn: () => api.get<EquipmentsResponse>('equipments/raw'),
		staleTime: Number.POSITIVE_INFINITY,
	});

	// Automatically cache fetched equipments in the normalized store
	useEffect(() => {
		if (queryResult.data?.data) {
			dispatch(equipmentSliceActions.setAll(queryResult.data.data));
		}
	}, [queryResult.data, dispatch]);

	return queryResult;
}

export { useLoadAllEquipmentsRawQuery };
